// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type Constant from '../contract/Constant';

export default function constant(data: Constant): Constant {
    const result: Constant = {
        __type: 'Constant:#Exchange',
        ...data,
    };

    return result;
}
